<div class="{{ theme$ | async }} d-flex custom-sidenav-container">
  <app-sidebar
    #sidebar
    class="vh-100 shadow print-hide"
  ></app-sidebar>
  <div
    class="content h-100 custom-sidenav-content small-device-margin"
    [style.width.px]="contentWidth"
  >
    <app-header class="print-hide"></app-header>
    <div
      class="main-wrapper p-3"
      #mainWrapper
      cdkVirtualScrollingElement
    >
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
